enum SortOrders {
  ASC = 'ASC',
  DESC = 'DESC',
}

export { SortOrders }
